(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["norelique-mobile-nav"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const dock = document.querySelector('.nr-mobile-dock');
    if (!dock || dock.dataset.ready) return;
    dock.dataset.ready = 'true';
    const cartLink = dock.querySelector('.nr-dock-cart');
    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', event => { if (typeof drawer.open !== 'function') return; event.preventDefault(); drawer.open(cartLink); });
      cartLink.addEventListener('keydown', event => { if (event.code === 'Space') { event.preventDefault(); cartLink.click(); } });
    }
    const headerCart = document.getElementById('cart-icon-bubble');
    const count = dock.querySelector('.nr-dock-count');
    const sync = () => {
      const number = headerCart?.querySelector('.cart-count-bubble span[aria-hidden="true"]')?.textContent.trim() || '';
      count.textContent = number;
      count.hidden = !number || number === '0';
    };
    if (headerCart) { new MutationObserver(sync).observe(headerCart, {childList:true,subtree:true,characterData:true}); sync(); }
    const sheet = document.getElementById('nr-support-sheet');
    const supportLink = dock.querySelector('.nr-dock-support');
    if (sheet && typeof sheet.showModal === 'function') {
      supportLink.setAttribute('role','button');
      supportLink.setAttribute('aria-haspopup','dialog');
      supportLink.setAttribute('aria-controls',sheet.id);
      supportLink.addEventListener('click',event => { event.preventDefault(); sheet.showModal(); });
      supportLink.addEventListener('keydown',event => { if(event.code === 'Space') { event.preventDefault(); supportLink.click(); } });
      sheet.addEventListener('click',event => { if(event.target !== sheet) return; const b=sheet.getBoundingClientRect(); if(event.clientX<b.left || event.clientX>b.right || event.clientY<b.top || event.clientY>b.bottom) sheet.close(); });
      sheet.addEventListener('close',() => supportLink.focus());
      matchMedia('(max-width:749px)').addEventListener('change',e=>{if(!e.matches && sheet.open) sheet.close();});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',setup); else setup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["norelique-sticky-buy"] && !Shopify.designMode) return;
  try {
    (() => {
  const setup = () => {
    const bar = document.querySelector('.nr-sticky-buy');
    const info = document.querySelector('product-info');
    if (!bar || !info || bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const button = bar.querySelector('button');
    const getSubmit = () => info.querySelector('product-form button[name="add"]');
    const sync = () => {
      const submit = getSubmit();
      if (!submit) { bar.hidden = true; return; }
      button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      const label = submit.querySelector('span:not(.loading__spinner)');
      if (label) button.textContent = label.textContent.trim();
      const priceBox = info.querySelector('[id^="price-"]');
      const price = priceBox?.querySelector('.price--on-sale .price-item--sale') || priceBox?.querySelector('.price-item--regular');
      if (price) bar.querySelector('.nr-sticky-price').textContent = price.textContent.trim();
    };
    button.addEventListener('click', () => {
      const submit = getSubmit();
      if (submit && !submit.disabled) submit.click();
    });
    const submit = getSubmit();
    if (submit) new IntersectionObserver(entries => {
      bar.hidden = entries[0].isIntersecting;
      document.body.classList.toggle('nr-has-buybar', !bar.hidden);
    }).observe(submit);
    new MutationObserver(sync).observe(info, {childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
  } catch(e) { console.error(e); }
})();

})();
